import { SVGProps } from "react";

export function FolderWithBG(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      {...props}
    >
      <circle cx="60" cy="60" r="60" fill="#EAF6EC" />
      <path
        d="M76.7984 79.1999H43.1984C41.9254 79.1999 40.7045 78.6942 39.8043 77.7941C38.9042 76.8939 38.3984 75.673 38.3984 74.3999V52.7999C38.3984 51.5269 38.9042 50.306 39.8043 49.4058C40.7045 48.5057 41.9254 47.9999 43.1984 47.9999H76.7984C78.0715 47.9999 79.2924 48.5057 80.1926 49.4058C81.0927 50.306 81.5984 51.5269 81.5984 52.7999V74.3999C81.5984 75.673 81.0927 76.8939 80.1926 77.7941C79.2924 78.6942 78.0715 79.1999 76.7984 79.1999Z"
        stroke="#28A745"
        stroke-width="3.6"
      />
      <path
        d="M70.8016 64.8C70.4833 64.8 70.1781 64.6736 69.953 64.4485C69.728 64.2235 69.6016 63.9183 69.6016 63.6C69.6016 63.2817 69.728 62.9765 69.953 62.7515C70.1781 62.5264 70.4833 62.4 70.8016 62.4C71.1198 62.4 71.425 62.5264 71.6501 62.7515C71.8751 62.9765 72.0016 63.2817 72.0016 63.6C72.0016 63.9183 71.8751 64.2235 71.6501 64.4485C71.425 64.6736 71.1198 64.8 70.8016 64.8Z"
        fill="#28A745"
        stroke="#28A745"
        stroke-width="3.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M74.3984 47.9999V44.6471C74.3982 43.9116 74.229 43.1858 73.9037 42.5261C73.5785 41.8663 73.1059 41.2901 72.5226 40.842C71.9392 40.3939 71.2607 40.0858 70.5394 39.9416C69.818 39.7974 69.0732 39.8209 68.3624 40.0103L41.9624 47.0495C40.9402 47.322 40.0365 47.9245 39.392 48.7634C38.7475 49.6024 38.3982 50.6308 38.3984 51.6887V52.7999"
        stroke="#28A745"
        stroke-width="3.6"
      />
    </svg>
  );
}

